//node_modules
import React, { FunctionComponent } from "react";
import { Card, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

//components
import StarRatingComponent from "@adjust/website/src/components/StarRatingComponent";

//types
import type { TestimonialDocument } from "@adjust/libs/database/testimonials";

type TestimonialProps = {
  testimonial: TestimonialDocument;
};

const TestimonialComponent: FunctionComponent<TestimonialProps> = ({ testimonial }) => {
  return (
    <Col lg={6} className="d-flex">
      <Card className="border-1 shadow-sm rounded-4 h-100 w-100">
        <Card.Body className="p-4 d-flex flex-column">
          {/* Title */}

          <h2 className="h4 fw-bold mb-2">{testimonial.title}</h2>

          {/* Destination */}

          <p className="text-primary fw-semibold mb-3">{testimonial.locations}</p>

          {/* Rating */}

          <div className="mb-3">
            <StarRatingComponent rating={testimonial.rating} />
          </div>

          {/* Review */}

          <p
            className="text-muted flex-grow-1"
            style={{
              lineHeight: 1.75,
              whiteSpace: "pre-line",
            }}
          >
            "{testimonial.description}"
          </p>

          {/* Footer */}

          <hr className="my-1" />

          <div className="fw-bold">{testimonial.reviewer}</div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default React.memo(TestimonialComponent);
